module.exports = __webpack_public_path__ + "static/media/check-symbol.16b84974.svg";